//#region src/page-title.ts
let PageTitleDynamicKeys = /* @__PURE__ */ function(PageTitleDynamicKeys) {
	PageTitleDynamicKeys["Suffix"] = "{TITLE_SUFFIX}";
	PageTitleDynamicKeys["AccountName"] = "{ACCOUNT_NAME}";
	return PageTitleDynamicKeys;
}({});
let PageTitlePrefixes = /* @__PURE__ */ function(PageTitlePrefixes) {
	PageTitlePrefixes["Default"] = "My account";
	return PageTitlePrefixes;
}({});
//#endregion
export { PageTitleDynamicKeys, PageTitlePrefixes };

//# sourceMappingURL=page-title.mjs.map